const NO_SUBSCRIPTION_STATE = 'none'

function showsSubscriptionChip({ plansRestructureEnabled, subscriptionState }) {
  return !!plansRestructureEnabled && subscriptionState === NO_SUBSCRIPTION_STATE
}

export default showsSubscriptionChip
